// Searches for a key on an object in progressively more lenient ways in order to avoid
// minor differences in keys causing lookup failures.
export function fuzzyKeyLookup<T>(
  object: Record<string, T> | undefined | null,
  key: string | undefined | null
): T | undefined {
  if (!object || !key) return;

  const match = fuzzyKey(object, key);
  return match ? object[match] : undefined;
}

export function fuzzyKey<T>(
  object: Record<string, T> | undefined | null,
  key: string | undefined | null
): string | undefined {
  if (!object || !key) return;
  if (key in object) return key;

  const fuzzyTest = (mut: (k: string) => string) => {
    return Object.keys(object).find(k => mut(k.toString()) === mut(key));
  };
  return fuzzyTest(k => k.toLowerCase()) || fuzzyTest(k => k.replaceAll('_', '').toLowerCase());
}
